import { render } from "./NewBedrijf.vue?vue&type=template&id=6a0e1300"
import script from "./NewBedrijf.vue?vue&type=script&lang=js"
export * from "./NewBedrijf.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__